import { useCallback, useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import { Cancel, CheckCircle, DeleteSweepRounded } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import Search from '@mui/icons-material/Search';
import { ButtonGroup } from '@mui/material';
import Button from '@mui/material/Button';
import DataGridJoy from '../../../../components/DataGridJoy';
import { useFetch } from '../../../../hooks/useFecth';
import { SearchDrawerOffers } from '../../Advertiser/components/SearchDrawerOffers';
import DialogOffer from './DialogOffer';
import useDialog from '../../../../hooks/useDialog';
import ClubTabLayout from '../../Clubs/components/ClubTabLayout';

export default function ListOffers({ advertiser }) {
    const { id: routeAdvertiserId } = useParams();
    const offersUsePortal = !routeAdvertiserId;
    const offersUrl = offersUsePortal ? 'advertiser/offers' : 'offer';
    const {handleOpen} = useDialog('offer')
    const [isDrawerOpen, setDrawerOpen] = useState(false); 
    const [searchParams, setSearchParams] = useSearchParams();
    // const [searchQuery, setSearchQuery] = useState('');
    
    const { data, mutate } = useFetch(offersUrl, {
        params: offersUsePortal
            ? { ...Object.fromEntries(searchParams) }
            : { advertiserId: routeAdvertiserId, ...Object.fromEntries(searchParams) },
    });

    // Atualização da página
    const handleChangePage = useCallback(
        (value) => {
            setSearchParams((prev) => ({
                ...Object.fromEntries(prev),
                page: value,
            }));
        },
        [setSearchParams]
    );

    // Atualização de número de linhas por página
    const handleChangeRowsPerPage = useCallback(
        (value) => {
            setSearchParams((prev) => ({
                ...Object.fromEntries(prev),
                perPage: value,
            }));
        },
        [setSearchParams]
    );

    // Chamada para atualizar dados quando filtros mudam
    useEffect(() => {
        mutate(); 
    }, [searchParams, mutate]);

    // Verifica se há filtros aplicados
    const hasFilters = Array.from(searchParams.entries()).some(
        ([key, value]) => value !== '' && value !== null
    );

    // Limpa os filtros aplicados
    const handleClearFilters = () => {
        setSearchParams({});
    };

    return (
        <>
            <ClubTabLayout
                actions={
                    <ButtonGroup size="small">
                        <Button variant="outlined" component={Link} to="#offer">
                            Adicionar oferta
                        </Button>
                        <Button variant="outlined" onClick={() => setDrawerOpen(true)}>
                            <Search />
                        </Button>
                        {hasFilters && (
                            <Button color="primary" onClick={handleClearFilters}>
                                <DeleteSweepRounded />
                            </Button>
                        )}
                    </ButtonGroup>
                }
            >
                <DataGridJoy
                    rows={data?.rows || []}
                    page={data?.page || 0}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    rowsPerPage={data?.rowsPerPage || 10}
                    numRows={data?.numRows || 0}
                    columns={[
                        { field: 'id', headerName: '#ID', width: 50 },
                        { field: 'name', headerName: 'Titulo', flex: 1 },
                        {
                            field: 'updatedAt',
                            headerName: 'Ultima alteração',
                            type: 'datetime',
                        },
                        {
                            field: 'status',
                            headerName: 'Status',
                            type: 'boolean',
                            width: 120,
                            render: ({ row }) => (row.status ? <CheckCircle color="success" /> : <Cancel color="error" />),
                        },
                        {
                            field: 'action',
                            headerName: 'Ações',
                            type: 'action',
                            width: 50,
                            render: ({ row }) => (
                                <IconButton size="small" onClick={e => handleOpen(row.id)}>
                                    <EditIcon />
                                </IconButton>
                            ),
                        },
                    ]}
                />
            </ClubTabLayout>
            <DialogOffer mutate={mutate} advertiser={advertiser} />
            <SearchDrawerOffers
                mutate={mutate}
                open={isDrawerOpen}
                onClose={() => setDrawerOpen(false)}
                onClearFilters={handleClearFilters}
            />
        </>
    );
}